function asyncIterableStream<T>(stream: ReadableStream<T>): AsyncIterable<T> {
  const reader = stream.getReader();

  return {
    [Symbol.asyncIterator]() {
      return {
        async next() {
          try {
            const { done, value } = await reader.read();
            if (done) {
              reader.releaseLock();
              return { done: true, value: undefined };
            }
            return { done: false, value };
          } catch (e) {
            reader.releaseLock();
            throw e;
          }
        },
      };
    },
  };
}

export function getAsyncTextStream(
  readableStream: ReadableStream,
): AsyncIterable<string> {
  const stream = new ReadableStream({
    start(controller) {
      const reader = readableStream.getReader();
      return pump();

      function pump(): Promise<void> {
        return reader.read().then(({ done, value }) => {
          if (done) {
            controller.close();
            return;
          }
          controller.enqueue(new TextDecoder().decode(value));
          return pump();
        });
      }
    },
  });
  return asyncIterableStream(stream);
}
